<template>
  <v-footer class="app-footer">
    <v-container>
      <v-row align="start">
        <v-col cols="12" md="5">
          <h2 class="app-footer__brand">{{ websiteName }}</h2>
          <p class="app-footer__description">
            Dienstleistungen wählen, Unternehmen und Preise vergleichen, Auftrag senden.
          </p>
        </v-col>

        <v-col cols="6" md="3">
          <h3 class="app-footer__title">Informationen</h3>
          <v-btn
              v-for="link in informationLinks"
              :key="link.path"
              class="app-footer__link"
              variant="text"
              @click="$router.push(link.path)"
          >
            {{ link.label }}
          </v-btn>
        </v-col>

        <v-col cols="6" md="4">
          <h3 class="app-footer__title">
            {{ user ? 'Mein Konto' : 'Kundenkonto' }}
          </h3>

          <v-btn
              v-if="!user"
              class="app-footer__link"
              variant="text"
              @click="showLogin"
          >
            <i class="fa-solid fa-arrow-right-to-bracket mr-2"/>
            Anmelden
          </v-btn>

          <v-btn
              v-if="!user"
              class="app-footer__link"
              variant="text"
              @click="showRegister"
          >
            <i class="fa-solid fa-user-plus mr-2"/>
            Registrieren
          </v-btn>
          <v-btn
              v-if="!user"
              class="app-footer__link"
              variant="text"
              @click="$router.push('/companyregister')"
          >
            <i class="fa-solid fa-plus mr-2"/>Unternehmen eintragen
          </v-btn>
          <v-btn
              v-if="user?.type === 'user'"
              class="app-footer__link"
              variant="text"
              @click="showAccount"
          >
            <i class="fa-regular fa-circle-user mr-2"/>
            Account
          </v-btn>

          <v-btn
              v-if="user?.type === 'company'"
              class="app-footer__link"
              variant="text"
              @click="$router.push('/company')"
          >
            <i class="fa-solid fa-building-user mr-2"/>
            Unternehmensprofil
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="my-5"/>

      <v-col class="app-footer__copyright pa-0 text-center">
        © {{ currentYear }} {{ websiteName }}
      </v-col>
    </v-container>

    <ModalLogin ref="ModalLogin"/>
    <ModalRegister ref="ModalRegister"/>
    <ModalAccount ref="ModalAccount"/>
  </v-footer>
</template>

<script>
import {mapGetters} from 'vuex'
import ModalLogin from '@/components/modal/Login'
import ModalRegister from '@/components/modal/Register'
import ModalAccount from '@/components/modal/Account'
import {getHomeSettings} from '@/services/siteSettings'

export default {
  name: 'AppFooter',

  components: {
    ModalLogin,
    ModalRegister,
    ModalAccount
  },

  data() {
    return {
      websiteName: 'MyService',
      informationLinks: [
        {label: 'FAQ', path: '/faq'},
        {label: 'Impressum', path: '/impressum'},
        {label: 'Datenschutz', path: '/datenschutz'}
      ]
    }
  },

  computed: {
    ...mapGetters(['user']),
    currentYear() {
      return new Date().getFullYear()
    }
  },

  methods: {
    async loadWebsiteName() {
      try {
        const response = await getHomeSettings()
        this.websiteName = response.data?.settings?.websiteName || 'MyService'
      } catch (error) {
        this.websiteName = 'MyService'
      }
    },
    showLogin() {
      this.$refs.ModalLogin.setState(true)
    },
    showRegister() {
      this.$refs.ModalRegister.setState(true)
    },
    showAccount() {
      this.$refs.ModalAccount.setState(true)
    }
  },

  mounted() {
    this.loadWebsiteName()
  }
}
</script>
